import projectConfig from '@/config/config';
const baseURL = projectConfig.baseURL;
const api = {
  // 发货确认列表
  confirmationPaymentPage: baseURL + '/trade/app/personal/confirmation/payment/paymentPage',
  // 发起人脸认证
  confirmationInitFaceVerify: baseURL + '/trade/app/personal/confirmation/InitFaceVerify',
  // 检查人脸照片
  checkFaceImage: baseURL + '/trade/app/personal/confirmation/checkFaceImage'
};

export default api;
